<template>
  <div>
    <div class="d-flex flex-wrap">
      <div v-for="(character, i) in characters" :key="i">
        <v-hover v-slot="{ hover }">
          <v-card class="ma-1" :elevation="hover ? 16 : 2" :class="{ 'on-hover': hover }" width="240" min-height="240">
            <v-img :src="character.imgUrl">
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="black"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
            <v-card-actions>
              <v-btn color="red" icon>
                <v-icon>mdi-heart</v-icon>
              </v-btn>
              <span>{{ character.heartCount }} </span>
            </v-card-actions>
          </v-card>
        </v-hover>
      </div>
    </div>
    <v-pagination></v-pagination>
  </div>
</template>

<script>
const characters = [
  {
    id: 1,
    imgUrl:
      "https://media.cgtrader.com/variants/WVkHS96BjsMpYsT3hE5Sgmoc/508c09fe26e63b93baec6d888aa2950650a509b5e04f2f03a4f2af52a04363ea/Rend_0000.jpg",
    heartCount: 12,
  },
  {
    id: 2,
    imgUrl:
      "https://media.cgtrader.com/variants/sfbWzfVJx2nghz6vWKyPzoDi/508c09fe26e63b93baec6d888aa2950650a509b5e04f2f03a4f2af52a04363ea/Rend_0000.jpg",
    heartCount: 4,
  },
  {
    id: 3,
    imgUrl:
      "https://media.cgtrader.com/variants/EgXiWcDK4bjq51YfaUxAaamC/508c09fe26e63b93baec6d888aa2950650a509b5e04f2f03a4f2af52a04363ea/Rend_00000.jpg",
    heartCount: 9,
  },
  {
    id: 4,
    imgUrl:
      "https://media.cgtrader.com/variants/bSuVFgvsndWV8FPYxVLq2rRe/508c09fe26e63b93baec6d888aa2950650a509b5e04f2f03a4f2af52a04363ea/Rend_0000.jpg",
    heartCount: 11,
  },
  {
    id: 5,
    imgUrl:
      "https://media.cgtrader.com/variants/Ny6ErsVLNQjBDFgzBNF3pV2i/508c09fe26e63b93baec6d888aa2950650a509b5e04f2f03a4f2af52a04363ea/Rend_0000.jpg",
    heartCount: 12,
  },
  {
    id: 6,
    imgUrl:
      "https://media.cgtrader.com/variants/TZSEHHrmAzuahUW3fhNVhWun/508c09fe26e63b93baec6d888aa2950650a509b5e04f2f03a4f2af52a04363ea/Rend_0000.jpg",
    heartCount: 24,
  },
  {
    id: 7,
    imgUrl:
      "https://media.cgtrader.com/variants/nzzT5dXqwYqXbDthkP6QcvVc/508c09fe26e63b93baec6d888aa2950650a509b5e04f2f03a4f2af52a04363ea/Rend_0000.jpg",
    heartCount: 14,
  },
  {
    id: 8,
    imgUrl:
      "https://media.cgtrader.com/variants/dxyL1nituzn3ASTaWrqrCdMX/508c09fe26e63b93baec6d888aa2950650a509b5e04f2f03a4f2af52a04363ea/Rend_0000.jpg",
    heartCount: 17,
  },
  {
    id: 9,
    imgUrl: "/cdn/v1/assets/characters/001.jpg",
    heartCount: 17,
  },
];
export default {
  data() {
    return {
      characters,
    };
  },
};
</script>

<style></style>
